import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import { getAppliedPromos } from '../../../redux_store/promotions/promotion_thunk';
import LoadingModal from '../../templates/modals/LoadingModal';
import { LOADING } from '../../../redux_store/actionTypes';
import { Gift, ClockOutline } from 'iconoir-react';

const AppliedPromotionsPage = () => {
  const { promotions, status } = useSelector((state) => state.promotion);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAppliedPromos());
    // eslint-disable-next-line
  }, [])

  return (
    <div className='space-y-6'>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}

      {/* Page Header */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-surface-800'>Applied Promotions</h1>
          <p className='text-surface-500 mt-1'>View all users who have applied promo codes</p>
        </div>
      </div>

      {promotions && promotions.length > 0 ?
        promotions.map((promo, promoIndex) => {
          let diff = 0;
          if (promo.promoDetails) {
            const expiry_date = moment(promo.promoDetails.expiry_date);
            const now = moment();
            diff = expiry_date.diff(now, 'days');
          }
          return (
            <div key={promoIndex} className='card p-0 overflow-hidden'>
              {/* Promo Header */}
              <div className='px-6 py-4 border-b border-surface-100 flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                  <div className='w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center'>
                    <Gift strokeWidth={2} className='w-5 h-5 text-indigo-600' />
                  </div>
                  <div>
                    <span className='font-mono font-bold text-lg text-surface-800'>
                      {promo.promoDetails?.promo_code || 'PROMO'}
                    </span>
                  </div>
                </div>
                <div className='flex items-center gap-2'>
                  <ClockOutline strokeWidth={2} className='w-4 h-4 text-surface-400' />
                  {diff > 0 ? (
                    <span className='badge-success'>Expires in {diff} day(s)</span>
                  ) : diff === 0 ? (
                    <span className='badge-warning'>Expires today</span>
                  ) : (
                    <span className='badge-danger'>Expired {-diff} day(s) ago</span>
                  )}
                </div>
              </div>

              {/* Applied Users Table */}
              <table className="table-modern">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Times Applied</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {promo.appliedPromos && promo.appliedPromos.map((appliedPromo, index) =>
                    <tr key={appliedPromo.id || index}>
                      <td>
                        <div className="flex items-center gap-3">
                          <img
                            className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                            src={appliedPromo.user?.profile_pic}
                            alt=""
                            loading="lazy"
                          />
                          <div>
                            <p className="font-semibold text-surface-800">
                              {appliedPromo.user?.surname} {appliedPromo.user?.other_names}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className='badge bg-surface-100 text-surface-600'>
                          {appliedPromo.total_usage} time(s)
                        </span>
                      </td>
                      <td>
                        {appliedPromo.is_active ? (
                          <span className='badge-warning'>Pending Use</span>
                        ) : (
                          <span className='badge-success'>Used</span>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )
        }) :
        <div className='card'>
          <div className='flex flex-col items-center py-12'>
            <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center mb-4'>
              <Gift strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
            </div>
            <p className='font-medium text-surface-600'>No promotions applied</p>
            <p className='text-sm text-surface-400'>No users have applied promo codes yet</p>
          </div>
        </div>
      }
    </div>
  )
}

export default AppliedPromotionsPage
